import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a vertical ellipsis icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/ellipsis-vertical?f=classic&s=solid
 */
export const EllipsisVerticalIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faEllipsisVertical} {...props} />;
};
